"use client";

import { useEffect, useState, type ComponentPropsWithoutRef } from "react";
import Image from "next/image";
import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";

type EmptyPresetsIllustrationProps = Omit<
  ComponentPropsWithoutRef<typeof Image>,
  "src" | "alt"
> & {
  alt?: string;
};

function useEmptyPresetsIllustrationSrc() {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return "/assets/empty-presets.svg";
  }

  return resolvedTheme === "light"
    ? "/assets/light/presets-empty.svg"
    : "/assets/empty-presets.svg";
}

export function EmptyPresetsIllustration({
  className,
  alt = "",
  width = 215,
  height = 140,
  ...props
}: EmptyPresetsIllustrationProps) {
  const src = useEmptyPresetsIllustrationSrc();

  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={cn("h-[140px] w-[215px]", className)}
      {...props}
    />
  );
}
